import React from 'react';
import Tasks from './components/tasks';
import Layout from '@/common/Layout';
import FloatingActionButton from '../FloatingActionButton';
import { getLoggedInUser } from 'utilities/helpers';
const EmployeeTasks = () => {
  const user = getLoggedInUser();
  return (
    <Layout sider={false}>
      <Tasks />
      {[1, 3].includes(user?.user_details?.role_id) ? (
        <FloatingActionButton />
      ) : (
        ''
      )}
    </Layout>
  );
};

export default EmployeeTasks;
